window.addEventListener('load', function () {
  if (!document.querySelector('.start_calendar')) return;

  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const date = hour * 24;

  const yearEl = document.querySelector('.event_year');
  const monthEl = document.querySelector('.event_month');
  const dateEl = document.querySelector('.event_date');
  const hourEl = document.querySelector('.event-end-hour');
  if (!yearEl || !monthEl || !dateEl || !hourEl) return;

  const endYear = parseInt(yearEl.dataset.value, 10);
  const endMonth = parseInt(monthEl.dataset.value, 10);
  const endDate = parseInt(dateEl.dataset.value, 10);
  const endHour = parseInt(hourEl.dataset.value, 10);

  const startYear = parseInt(yearEl.dataset.startValue, 10);
  const startMonth = parseInt(monthEl.dataset.startValue, 10);
  const startDate = parseInt(dateEl.dataset.startValue, 10);
  const startHour = parseInt(hourEl.dataset.startValue, 10);

  const countDown = new Date(endYear, endMonth, endDate, endHour).getTime();
  const startDown = new Date(startYear, startMonth, startDate, startHour).getTime();

  const timerWrapper = document.querySelector('.custom-timer-wrapper');
  const dayEls = document.querySelectorAll('.js-timer-days');
  const hourEls = document.querySelectorAll('.js-timer-hours');
  const minuteEls = document.querySelectorAll('.js-timer-minutes');
  const secondEls = document.querySelectorAll('.js-timer-seconds');
  const numEls = document.querySelectorAll('.hc_cd_timernum');
  const loadingEls = document.querySelectorAll('.timer_loading');

  let lastSecondKey = null;

  function setText(nodes, value) {
    nodes.forEach(function (item) {
      var strong = item.querySelector('strong');
      if (strong) strong.textContent = value;
    });
  }

  function tick() {
    const formattedDate = new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
    const nowtime = new Date(formattedDate).getTime();
    const startTimer = startDown - nowtime;

    if (startTimer >= 0) return;

    if (timerWrapper) timerWrapper.classList.remove('hidden');

    const distance = countDown - nowtime;
    if (distance <= 0) {
      if (timerWrapper) timerWrapper.classList.add('hidden');
      return false;
    }

    const totalDays = Math.floor(distance / date);
    const remainingHours = Math.floor((distance % date) / hour);
    const remainingMinutes = Math.floor((distance % hour) / minute);
    const remainingSeconds = Math.floor((distance % minute) / second);
    const secondKey =
      totalDays + '-' + remainingHours + '-' + remainingMinutes + '-' + remainingSeconds;

    if (secondKey === lastSecondKey) return true;
    lastSecondKey = secondKey;

    numEls.forEach(function (item) {
      item.classList.remove('hidden');
    });
    loadingEls.forEach(function (item) {
      item.classList.add('hidden');
    });

    setText(dayEls, totalDays);
    setText(hourEls, remainingHours);
    setText(minuteEls, remainingMinutes);
    setText(secondEls, remainingSeconds);
    return true;
  }

  function scheduleTick() {
    if (!tick()) return;
    window.setTimeout(scheduleTick, 1000);
  }

  if (tick()) scheduleTick();
});
